import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent'

export const getCouriers = (
  filters?: Filter[],
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.CourierApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters && filters.length > 0) {
    filters.forEach((filter) => {
      url.searchParams.set(filter.key, filter.value)
    })
  }

  return axios.get(url.toString())
}

export const deleteCourier = (courierId: number) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}`)
  return axios.delete(url.toString())
}
